export const HEADER_HEIGHT = '55px';
export const CANNY_CHANGELOG_URL = 'https://doubletick.canny.io/changelog';
